import { Component, input, ChangeDetectionStrategy, computed } from '@angular/core';
import { GeocodingResultGrade } from '../../shared/entities/address/address';

type IndicatorSize = 'small' | 'default';

@Component({
  selector: 'app-address-indicator-v2',
  template: `
    <div 
      class="circle"
      [class.small]="size() === 'small'"
      [class.red]="isRed()"
      [class.yellow]="isYellow()"
      [class.green]="isGreen()">
    </div>
  `,
  styles: [`
    :host {
      display: inline-flex;
    }

    .circle {
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      display: inline-block;
      background-color: #F2F2F2;
    }

    .circle.small {
      width: 0.7rem;
      height: 0.7rem;
    }

    .red {
      background-color: rgb(218, 0, 0);
    }

    .green {
      background-color: green;
    }
    
    .yellow {
      background-color: rgb(255, 174, 0);
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressIndicatorV2Component {
  readonly grade = input<GeocodingResultGrade | string | number>();
  readonly size = input<IndicatorSize>('default');

  /**
   * GraphQL returns the enum as a string ("GREEN", "YELLOW", "RED") while TypeScript
   * enums are numeric (GREEN=0, YELLOW=1, RED=2). We need to handle both formats
   * because the API serializes enums to strings, but internal code might use the enum values.
   * This is why we check for: enum reference, string literal, and numeric value.
   */
  protected readonly isGreen = computed(() => {
    const g = this.grade();
    return g === GeocodingResultGrade.GREEN || g === 'GREEN' || (typeof g === 'number' && g === 0);
  });

  protected readonly isYellow = computed(() => {
    const g = this.grade();
    return g === GeocodingResultGrade.YELLOW || g === 'YELLOW' || (typeof g === 'number' && g === 1);
  });

  protected readonly isRed = computed(() => {
    const g = this.grade();
    return g === GeocodingResultGrade.RED || g === 'RED' || (typeof g === 'number' && g === 2);
  });
}
